module.exports = __webpack_public_path__ + "static/img/200238.e0356f4e.png";